import { useCallback, useContext } from 'react';
import { SnackbarContext } from '../providers/SnackBarProvider';

// Convenience wrapper around SnackbarContext.
// Returns showSnackbar(text, severity) — severity is a MUI Alert severity string
// ('success' | 'error' | 'warning' | 'info').
export const useSnackbar = () => {
	const { setSnackbar } = useContext(SnackbarContext);

	const showSnackbar = useCallback(
		(text, severity = 'info') => {
			setSnackbar({ text, severity });
		},
		[setSnackbar],
	);

	return { showSnackbar };
};
